module.exports = __webpack_public_path__ + "media/images/flags/MM-0d12c56cad55121a374a3a869190e42e.svg";